"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var FieldData = function FieldData(_ref) {
  var label = _ref.label,
    payload = _ref.payload,
    fieldType = _ref.fieldType;
  var renderInputFields = function renderInputFields() {
    switch (fieldType) {
      case 'address':
        {
          var address = payload.split(',');
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
            title: label,
            className: "field-label"
          }, label), /*#__PURE__*/_react.default.createElement("div", {
            className: "address"
          }, address.map(function (a) {
            return /*#__PURE__*/_react.default.createElement("span", {
              key: a
            }, a);
          })));
        }
      default:
        {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
            title: label,
            className: "field-label"
          }, label), /*#__PURE__*/_react.default.createElement("span", null, payload));
        }
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "customer-data"
  }, renderInputFields());
};
var _default = FieldData;
exports.default = _default;